export default __webpack_public_path__ + "static/media/gamePhone.5a0c70b4.png";